import { jsx } from "react/jsx-runtime";
import React from "react";
const ChatContext = React.createContext({
  state: null,
  apiClient: null,
  chatConfiguration: null
});
const useChatContext = () => React.useContext(ChatContext);
const withChatContext = (Component) => {
  const WithChatContext = (props) => {
    const context = useChatContext();
    return /* @__PURE__ */ jsx(
      Component,
      {
        ...props,
        chatConfiguration: context.chatConfiguration,
        apiClient: context.apiClient,
        chatState: context.state
      }
    );
  };
  return WithChatContext;
};
export {
  ChatContext,
  ChatContext as default,
  useChatContext,
  withChatContext
};
//# sourceMappingURL=Context.js.map
